<template>
    <RemoteTable ref="table" :form="form" :table="table">
        <template #default="{row, property}">
            <template v-if="property === 'channel'">
                {{getChannelName(row.channel)}}
            </template>
            <template v-else-if="property === 'count'">
                {{row.success + row.unknown}}
            </template>
            <template v-else-if="property === 'rate'">
                {{getRate(row)}}
            </template>
        </template>
    </RemoteTable>
</template>

<script>
    import RemoteTable from '@/components/RemoteTable'

    export default {
        components: {
            RemoteTable
        },
        data() {
            return {
                form: {
                    configs: [
                        {label: "通道", name: "channel", type: "select", value: "", options: []},
                        {label: "日期", name: "date", type: "daterange", op: "between", value: []},
                    ],
                    tools: [
                        {
                            label: "导出",
                            click: () => {
                              this.$confirm("确认进行导出操作？", "提示", {
                                confirmButtonText: "确认",
                                cancelButtonText: "取消",
                                type: 'warning'
                              }).then(() => {
                                this.$axios.post('/channelsummary/download', this.$refs.table.getQueryInfo()).then(response => {
                                  this.$utils.download("/file/pop/" + response);
                                });
                              });
                            }
                        }
                    ]
                },
                table: {
                    urlPrefix: "/channelsummary",
                    defaultSort: {prop: 'id', order: 'descending'},
                    columns: [
                        {label: "日期", name: "date", width: 100},
                        {label: "通道", name: "channel"},
                        {label: "发送数", name: "send", width: 120, sortable: true},
                        {label: "预计费数", name: "total", width: 100, sortable: true},
                        {label: "成功数", name: "success", width: 100, sortable: true},
                        {label: "失败数", name: "fail", width: 100, sortable: true},
                        {label: "无状态数", name: "unknown", width: 100, sortable: true},
                        {label: "实计费数", name: "count", width: 100, sortable: true},
                        {label: "成功率", name: "rate", width: 100},
                    ],
                },
                channels: []
            }
        },
        mounted() {
            let options = [];
            this.$axios.post("/channel/list").then(results => {
                results.forEach(result => {
                    options.push({value: result.code, label: result.name});
                });

                this.$set(this.form.configs[0], 'options', options);
                this.channels = options;
            });
        },
        methods: {
            getChannelName(val) {
                let name = "";
                this.channels.forEach(option => {
                    if (val === option.value) {
                        name = option.label;
                        return false;
                    }
                });
                return name;
            },
            getRate(row) {
                let total = row.success + row.fail + row.unknown;
                if (total === 0) {
                    return "--";
                }
                return ((row.success + row.unknown) / total * 100).toFixed(2) + "%";
            }
        }
    }
</script>